// tslint:disable:max-line-length

import React from 'react';

export const ActionStarFavorite = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" {...props}>
      <path
        d="M7.08203 1.24219C7.24609 0.914062 7.51041 0.75 7.87499 0.75C8.23958 0.75 8.5039 0.914062 8.66796 1.24219L10.4453 4.85156L14.4375 5.45312C14.8021 5.48958 15.0391 5.68099 15.1484 6.02734C15.2578 6.3737 15.1849 6.67448 14.9297 6.92969L12.0312 9.74609L12.7148 13.7383C12.7695 14.0846 12.651 14.3581 12.3594 14.5586C12.0677 14.7773 11.7669 14.8047 11.457 14.6406L7.87499 12.7812L4.29296 14.6406C3.98307 14.8229 3.68229 14.8047 3.39062 14.5859C3.09895 14.3672 2.98046 14.0846 3.03515 13.7383L3.71874 9.74609L0.820306 6.92969C0.565098 6.67448 0.492181 6.3737 0.601556 6.02734C0.710931 5.68099 0.947911 5.48958 1.31249 5.45312L5.30468 4.85156L7.08203 1.24219Z"
        fill="#D9B55B"
      />
    </svg>
  );
};
